import '../assets/css/swim_view.css';
import ImagesLightboxModal from '../../common/ImagesLightboxModal';
import { useEffect, useState } from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { Button } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { PlaceholderImage } from '../../common/components/sliders/components/SliderImages';
import { exotic_fishery } from '../../common/Utils';
function SwimViewView({ imageSrc, name, wide = false, onClick = () => {} }) {
  return (
    <div
      className={'swim-view__view ' + (wide ? 'swim-view__view--wide' : '')}
      onClick={onClick}
    >
      <PlaceholderImage
        src={imageSrc}
        alt={`View of ${name}`}
        className={'swim-view__view__image'}
      />
      <span className={'swim-view__view__label'}>{name}</span>
    </div>
  );
}

function SwimView({ swims, fisheryPublicId }) {
  const [lightboxIndex, setLightboxIndex] = useState(null);

  return (
    <>
      <div className={'swim-view'}>
        <div className={'swim-view__swims_container'}>
          <SwimViewView
            imageSrc={swims.overlay}
            name={
              fisheryPublicId == exotic_fishery ? 'Overlay' : 'Lake Overlay'
            }
            wide
            onClick={() => setLightboxIndex(0)}
          />
          {swims.swims.map((view, i) => (
            <SwimViewView
              key={`swim ${i}`}
              imageSrc={view.image}
              name={view.name}
              onClick={() => setLightboxIndex(i + 1)}
            />
          ))}
        </div>
      </div>

      <ImagesLightboxModal
        isOpen={lightboxIndex !== null}
        initialIndex={lightboxIndex}
        onClose={() => setLightboxIndex(null)}
        images={[
          { src: swims.overlay, alt: 'Lake Overlay' },
          ...swims.swims.map((view) => ({
            src: view.image,
            alt: `View of ${view.name}`,
          })),
        ]}
        titles={[
          fisheryPublicId == exotic_fishery ? 'Overlay' : 'Lake Overlay',
          ...swims.swims.map((view) => view.name),
        ]}
        loading={!swims}
        hideImageCount
      />
    </>
  );
}

const SwimViewsHeader = ({
  lakeName,
  numSlides,
  setCurrentSlide,
  next,
  previous,
  ...rest
}) => {
  const {
    carouselState: { currentSlide },
  } = rest;

  useEffect(() => {
    setCurrentSlide(currentSlide);
  }, [setCurrentSlide, currentSlide]);

  return (
    <div className={'swim-views__header mg-bottom-20 mg-top-10'}>
      <Button
        onClick={() => {
          previous();
        }}
        disabled={currentSlide === 0}
        shape='circle'
        icon={<LeftOutlined />}
      />
      <h1 className={'gSemiBold fs-24 txt-single-line-ellipsis w-fit'}>
        {lakeName}
      </h1>
      <Button
        onClick={() => {
          next();
        }}
        disabled={currentSlide === numSlides - 1}
        shape='circle'
        icon={<RightOutlined />}
      />
    </div>
  );
};

export default function SwimViewer({ swimViews, fisheryPublicId }) {
  const [currentIndex, setCurrentIndex] = useState(0);

  return (
    <div className={'mg-top-20 swim-views__container'}>
      <Carousel
        swipeable={false}
        arrows={false}
        renderButtonGroupOutside={true}
        customButtonGroup={
          <SwimViewsHeader
            lakeName={swimViews[currentIndex].name}
            numSlides={swimViews.length}
            setCurrentSlide={setCurrentIndex}
          />
        }
        responsive={{
          single: {
            breakpoint: { max: 40000, min: 0 },
            items: 1,
          },
        }}
      >
        {swimViews.map((lakeSwimView) => (
          <SwimView
            swims={lakeSwimView.swims}
            fisheryPublicId={fisheryPublicId}
          />
        ))}
      </Carousel>
    </div>
  );
}
